import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import { DataTable } from "./partial/DataTable"
import { columns } from "./partial/Columns"

const getListKelompokVerifikasiPesertaIjazah = async (
  id_verijazah_rekap: string
) => {
  const response = await api.get(
    `/setting/verifikator-ijazah/show-kelompok/${id_verijazah_rekap}`,
    {
      withCredentials: true,
    }
  )
  return response.data
}

export default function SettingVerifikatorRaportDetailPage() {
  const [searchParams] = useSearchParams()
  const idVerIjazahRekap = searchParams.get("id")

  const { data, isPending } = useQuery({
    queryKey: ["listKelompokVerifikasiIjazah", idVerIjazahRekap],
    queryFn: () =>
      getListKelompokVerifikasiPesertaIjazah(String(idVerIjazahRekap)),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  )
}
